import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { Images } from 'assets/images';

export const ComponentTopBlock = styled.div`
  width: 100%;
  height: 110px;
`;

export const TitleAndAddButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
`;

export const TitleOfPage = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontMedium};
  text-transform: capitalize;
  color: ${COLORS.black};
`;

export const AddButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font18};
  text-transform: capitalize;
  border-radius: 8px;
`;

export const AboutContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const ShowQuantityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  height: 100%;
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: ${({ isStatus }) => (isStatus ? '100%' : '80px')};
  height: 32px;

  &::after {
    content: '';
    position: absolute;
    top: ${({ isStatus }) => (isStatus ? '22px' : '14px')};
    width: 10px;
    right: 10px;
    height: 6px;
    background: url(${Images.selectDownArrow});
    pointer-events: none;
  }
`;

export const DeleteAndSearchBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 684px;
  height: 32px;
`;

export const SelectOptionWrapper = styled.div`
  position: relative;
  width: 228px;
  height: 32px;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: 14px;
    width: 10px;
    right: 10px;
    height: 6px;
    background: url(${Images.selectDownArrow});
    pointer-events: none;
  }
`;

export const Select = styled.select`
  width: ${({ showContentNumbers }) => (showContentNumbers ? '100%' : '228px')};
  height: 32px;
  border-radius: 8px;
  padding-inline: 10px;
  margin-right: 10px;
  outline: none;
  border: 1px solid ${COLORS.mainColor};
  -webkit-appearance: none;
  ${FONTS.font16};
  cursor: pointer;

  &:nth-child(1) {
    color: ${COLORS.mainColor};
  }

  option {
    ${FONTS.font16};
  }
`;

export const DeleteAllButton = styled.button`
  width: 128px;
  height: 32px;
  background: ${COLORS.mainColor};
  border: 1px solid ${COLORS.lightSilver};
  color: ${COLORS.white};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px;

  &:hover {
    background: transparent;
    color: ${COLORS.lightSilver};
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
  padding-right: 10px;
`;

export const SearchInput = styled.input`
  width: 270px;
  height: 32px;
  padding-left: 10px;
  padding-right: 2px;
  background: transparent;
  border: none;
`;

export const SampleImage = styled.img``;
